export default [{
  path: '/priority',
  name: 'priority',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/priority/index')
}]
